<div tabindex="-1" #top class="govuk-util__no-focus">
  <app-cookie-banner></app-cookie-banner>
  <a class="govuk-skip-link" href="#main-content" (click)="skip($event)">Skip to main content</a>
  <app-header [showNotificationsLink]="standAloneAccount || parentAccount || subsAccount"></app-header>
  <div>
    @if (
      !isAdminSection && (standAloneAccount || parentAccount || subsAccount)) {
      @if (parentAccount || viewingSubsidiaryWorkplace) {
        <div>
          <app-navigate-to-workplace-dropdown [maxChildWorkplacesForDropdown]="31"></app-navigate-to-workplace-dropdown>
        </div>
      }
      @if (!viewingSubsidiaryWorkplace) {
        <app-stand-alone-account
          [dashboardView]="dashboardView"
          data-testid="stand-alone-account"
          >
        </app-stand-alone-account>
      }
      @if (viewingSubsidiaryWorkplace) {
        <app-subsidiary-account
          [dashboardView]="dashboardView"
          data-testid="subsidiary-account"
          >
        </app-subsidiary-account>
      }
    } @else {
      <div
        id="content"
        [class]="{ 'govuk-width-container': !isAdminSection, 'asc-width-container-admin-section': isAdminSection }"
        >
        <app-phase-banner></app-phase-banner>
        <app-back-link></app-back-link>
        <app-new-back-link></app-new-back-link>
        <app-breadcrumbs></app-breadcrumbs>
        <app-alert></app-alert>
        <main
          id="main-content"
          class="govuk-main-wrapper app-main-class govuk-util__no-focus"
          #content
          role="main"
          tabindex="-1"
          >
          <router-outlet> </router-outlet>
        </main>
      </div>
    }
    @if (showHelpButton) {
      <app-help-and-tips-button data-testid="help-and-tips-button"/>
    }
  </div>
  <app-footer></app-footer>

</div>
